export class DrugStudy{
  concernsExperimentationOrChanges: boolean;
  isExperimentationWithRisks: boolean;
  riskDescription: string;
  safeExperimentationProof: string;
}
